<template>
  <b-row
    class="d-flex flex-row align-items-start justify-content-start"
    no-gutters
  >
    <b-col class="d-flex flex-column align-items-start justify-content-start">
      <h6
        class="text-left text-dark font-weight-semi-bold font-primary mb-3 mt-3"
      >
        Add a new password
      </h6>
      <!-- Add a New Admin form -->
      <form
        id="admin-registration-form"
        class="d-flex flex-column align-items-start justify-content-start w-100"
      >
        <!-- full row input (Password) -->
        <b-row
          class="
            d-flex
            flex-row
            align-items-start
            justify-content-start
            w-100
            py-2
          "
          no-gutters
        >
          <b-col cols="12">
            <FormInputGroup
              groupId="password-group"
              id="password-group-input"
              v-model="password"
              :state="passwordError.status"
              :invalidFeedback="`${passwordError.message}`"
              label="Password"
              placeholder="Minimum 6 characters"
              isRequired
              :type="confirmNewPasswordShow ? 'text' : 'password'"
              form="admin-registration-form"
              isAppend
            >
              <template v-slot:append>
                <b-button
                  class="px-3 px-md-4 key-row"
                  variant="transparent"
                  @click="generatePassword"
                >
                  <font-awesome-icon icon="key"></font-awesome-icon>
                  <span> Securely Generate</span>
                </b-button>
              </template>
            </FormInputGroup>
          </b-col>
        </b-row>
        <!-- full row input (Confirm Password) -->
        <b-row
          class="d-flex flex-row align-items-start justify-content-start w-100"
          no-gutters
        >
          <b-col cols="12">
            <FormInputGroup
              groupId="password-group"
              id="password-group-input"
              v-model="confirmNewPassword"
              label="Confirm New Password"
              placeholder="Minimum 6 characters"
              isRequired
              :state="confirmNewPasswordError.status"
              :invalidFeedback="`${confirmNewPasswordError.message}`"
              :type="confirmNewPasswordShow ? 'text' : 'password'"
              form="reset-password-form"
              isAppend
            >
              <template v-slot:append>
                <b-button
                  class="
                    px-3 px-md-4
                    border border-gray
                    overflow-hidden
                    shadow-sm
                  "
                  variant="transparent"
                  @click="confirmNewPasswordShow = !confirmNewPasswordShow"
                >
                  <font-awesome-icon
                    class="text-prime-gray"
                    :icon="confirmNewPasswordShow ? 'eye-slash' : 'eye'"
                    aria-label="Help"
                  ></font-awesome-icon>
                </b-button>
              </template>
            </FormInputGroup>
          </b-col>
        </b-row>
        <!-- form action -->
        <b-row
          v-if="createPasswordError.status"
          class="
            d-flex
            flex-row
            align-items-center
            justify-content-center
            w-100
          "
          no-gutters
        >
          <!-- error message span class -->
          <b-col
            class="
              d-flex
              flex-column
              align-items-center
              justify-content-center
              px-0
              py-2
            "
            cols="9"
          >
            <span class="text-danger text-center" style="font-size: 0.8rem">{{
              createPasswordError.message
            }}</span>
          </b-col>
        </b-row>
        <!-- login button -->
        <b-row
          class="
            d-flex
            flex-row
            align-items-center
            justify-content-center
            w-100
          "
          no-gutters
        >
          <b-col
            class="
              d-flex
              flex-column
              align-items-center
              justify-content-center
              px-0
              py-2
            "
            cols="9"
            sm="6"
          >
            <FormButton
              variant="primary"
              isBlock
              class="font-weight-normal text-white mt-2 border-dark"
              type="submit"
              @click.native="createPassword"
              :isLoading="isAPILoading"
              >Add Password</FormButton
            >
          </b-col>
        </b-row>
      </form>
    </b-col>
  </b-row>
</template>

<script>
import FormInputGroup from "@/components/Form/FormInputGroup";
import FormButton from "@/components/Form/FormButton";
import { CreatePassword } from "@/services/passwords.service";

export default {
  name: "CreatePassword",
  components: {
    FormInputGroup,
    FormButton,
  },
  props: {
    passwordList: Array,
  },
  data() {
    return {
      password: null,
      confirmNewPassword: null,
      confirmNewPasswordShow: false,
      isAPILoading: false,
      confirmNewPasswordError: {
        status: null,
        message: "",
      },
      passwordError: {
        status: null,
        message: "",
      },
      createPasswordError: {
        status: null,
        message: "",
      },
      isReset: false,
    };
  },
  watch: {
    password(val) {
      this.errorFn(val);
    },
    confirmNewPassword(val) {
      this.errorFn(this.password, val);
    },
  },
  methods: {
    generatePassword() {
      var length = 6;
      var mask =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      var result = "";
      for (var i = length; i > 0; --i) {
        result += mask[Math.floor(Math.random() * mask.length)];
      }
      this.password = result;
      this.confirmNewPassword = result;
    },
    async createPassword() {
      var errors = this.errorFn();
      if (errors.length == 0) {
        let payload = {
          password: this.password,
          confirmNewPassword: this.confirmNewPassword,
        };
        try {
          this.isAPILoading = true;
          let { data } = await CreatePassword(payload);
          if (data.code == 200 && data.message == "success") {
            let payloadNotify = {
              isToast: true,
              title: "Password Creation",
              content: "Password has been created successfully",
              variant: "success",
            };
            this.$store.dispatch("notification/setNotify", payloadNotify);
            this.$emit("reloadFn");
            this.resetFn();
          } else {
            this.createPasswordError.status = false;
            this.createPasswordError.message = `An error occured when saving the password: ${data.details}`;

            //  notification
            let payloadNotify = {
              isToast: true,
              title: "Password Creation",
              content: "Unable to create password.",
              list: [data.details, data.errorCode],
              variant: "danger",
            };
            this.$store.dispatch("notification/setNotify", payloadNotify);
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.isAPILoading = false;
        }
      } else {
        let payloadNotify = {
          isToast: true,
          title: "Password Creation",
          content: "Unable to create password.",
          list: errors,
          variant: "danger",
        };

        this.$store.dispatch("notification/setNotify", payloadNotify);
      }
    },
    errorFn(
      password = this.password,
      confirmPassword = this.confirmNewPassword
    ) {
      var pwdErrors = this.validatePassword(password);
      var pwdConfirmErrors = this.validateConfirmPassword(confirmPassword);
      if (pwdErrors.length > 0) {
        this.passwordError.status = false;
        this.passwordError.message = pwdErrors[0];
      } else this.passwordError.status = true;

      if (pwdErrors.length == 0 && pwdConfirmErrors.length > 0) {
        this.confirmNewPasswordError.status = false;
        this.confirmNewPasswordError.message = pwdConfirmErrors[0];
      } else if (pwdConfirmErrors.length == 0)
        this.confirmNewPasswordError.status = true;
      else this.confirmNewPasswordError.status = null;

      return [...pwdErrors, ...pwdConfirmErrors];
    },
    validatePassword(val = this.password) {
      var errorList = [];
      if (!val) errorList.push("Please fill in the password");
      else if (val.length < 6)
        errorList.push("A minimum length of 6 characters is required");
      else if (this.passwordList.includes(val))
        errorList.push("This password is already added.");
      return errorList;
    },
    validateConfirmPassword(val = this.confirmNewPassword) {
      var errorList = [];
      if (!val) errorList.push("Please fill in your confirm password again");
      else if (val.length < 6)
        errorList.push(
          "A minimum length of 6 characters needed for the confirm password"
        );
      else if (val != this.password) errorList.push("Passwords do not match");
      return errorList;
    },
    resetFn() {
      this.isReset = true;
      this.password = "";
      this.confirmNewPassword = "";
      this.passwordError.status = null;
      this.confirmNewPasswordError.status = null;
      this.createPasswordError.status = null;
      setTimeout(() => (this.isReset = false), 100);
    },
  },
};
</script>

<style scoped>
.key-row {
  background-color: rgba(236, 239, 244, 1);
  border-radius: 0px 8px 8px 0px;
  border: 1px solid rgba(135, 147, 163, 0.25);
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
}

/* == FORM GROUP STYLING == */
/* customized form control */
#region-selector-group.form-group {
  position: relative;
}

#region-selector-group.form-group
  >>> select.region-selector-select::placeholder {
  color: var(--prime-gray);
}

/* == FORM SELECT STYLING == */
/* form custom select styling (default state) */
#region-selector-group.form-group >>> select.region-selector-select {
  min-height: 50px;
  border-radius: 0;
  background-color: transparent;
  color: var(--muted-gray);
}

#region-selector-group >>> select.region-selector-select option {
  color: #4f5467;
}

/* form custom select error state styling (valid state) */
#region-selector-group.form-group.is-valid >>> select.region-selector-select {
  border-color: var(--success);
}

/* form custom select error state styling (invalid state) */
#region-selector-group.form-group.is-invalid >>> select.region-selector-select {
  border-color: var(--danger);
}

/* form custom select focused styling (focus state) */
#region-selector-group.form-group.is-focus >>> select.region-selector-select {
  z-index: 0;
}

#region-selector-group.form-group >>> select.region-selector-select:focus {
  border-color: var(--info);
  box-shadow: none;
}

/* form custom select focused error state styling (focus/valid state) */
#region-selector-group.form-group.is-focus.is-valid
  >>> select.region-selector-select {
  border-color: var(--success);
}

/* form custom select focused error state styling (focus/invalid state) */
#region-selector-group.form-group.is-focus.is-invalid
  >>> select.region-selector-select {
  border-color: var(--danger);
}

/* form custom select disabled state styling (disabled state) */
#region-selector-group.form-group.is-disabled >>> select.region-selector-select,
#region-selector-group.form-group:disabled >>> select.region-selector-select {
  color: var(--ghost-white);
}

/* label styling */
#region-selector-group.form-group >>> legend.region-selector-label {
  position: absolute;
  color: var(--prime-gray);
  font-size: 1rem;
  /* width: auto; */
  width: calc(100% - 35px);
  top: 13px;
  left: 13px;
  z-index: 1;
  white-space: nowrap;
  word-wrap: normal;
  text-overflow: clip;
  user-select: none;
  pointer-events: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  transition: top 100ms linear 0s, left 100ms linear 0s, color 100ms linear 0s,
    font-size 300ms cubic-bezier(0.2, 0, 0, 1) 0s,
    opacity 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
}

/* form label focused styling (focus state) */
#region-selector-group.form-group.is-focus >>> legend.region-selector-label {
  font-size: 0.8rem;
  color: var(--info);
  width: auto;
  top: -9px;
  left: 10px;
  opacity: 1;
  z-index: 2;
}

/* form label focused error state styling (focus/valid state) */
#region-selector-group.form-group.is-focus.is-valid
  >>> legend.region-selector-label {
  color: var(--success);
}

/* form label focused error state styling (focus/invalid state) */
#region-selector-group.form-group.is-focus.is-invalid
  >>> legend.region-selector-label {
  color: var(--danger);
}

/* form label disabled state styling (disabled state) */
#region-selector-group.form-group:disabled >>> legend.region-selector-label,
#region-selector-group.form-group.is-disabled >>> legend.region-selector-label {
  color: var(--ghost-white);
}

/* label before psuedo element (default state) */
#region-selector-group.form-group >>> legend.region-selector-label:before {
  position: absolute;
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: var(--white);
  z-index: -1;
  pointer-events: none;
  transition: width 100ms linear 0s, height 100ms linear 0s;
}

/* form label background focused styling (focus state) */
#region-selector-group.form-group.is-focus
  >>> legend.region-selector-label::before {
  width: 100%;
  height: 100%;
}

/* form label background disabled focused styling (disabled/focus state) */
#region-selector-group.form-group:disabled.is-focus
  >>> legend.region-selector-label::before,
#region-selector-group.form-group.is-disabled.is-focus
  >>> legend.region-selector-label::before {
  background-color: var(--white);
  height: 3px;
  top: 8px;
}
</style>
